/* eslint-disable no-unused-vars */
export enum AppLanguage {
    Turkish = 'tr',
    English = 'en',
  }
